import { render, staticRenderFns } from "./NcalayerButton.vue?vue&type=template&id=14db5848&scoped=true&"
import script from "./NcalayerButton.vue?vue&type=script&lang=js&"
export * from "./NcalayerButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14db5848",
  null
  
)

export default component.exports